<template>
    <div>
        <div class="content-box mr60">
            <el-form ref="form" label-width="120px" :model="formItem" :rules="rules" class="form-wrap">
                <el-form-item :style="{marginBottom: '4px'}">
                    <span :style="{fontSize: '12px'}">结单代表终止工单全部制作任务，未验收的素材会全部验收，提交后无法继续上传素材及修改。</span>
                </el-form-item>
                <el-form-item label="结单：" prop="finish_reason" v-if="isFinish">
                    <el-input type="textarea" :autosize="{ minRows: 3, maxRows: 5 }" placeholder="请输入结单的理由，50字之内" v-model.trim="formItem.finish_reason" clearable maxlength="50" show-word-limit></el-input>
                </el-form-item>
            </el-form>
        </div>
        <p class="dialog-footer tac mt20">
            <el-button type="default" @click="hideModal" class="action-btn mr20">取消</el-button>
            <el-button type="primary" @click="submitModal" :loading="formLoading" class="action-btn ml20">提交</el-button>
        </p>
    </div>
</template>
<!-- 工单管理  结算-->
<script>

import API from "@/api/workOrder/material.js"
import matomoFun from "@/utils/matomo.js";
export default {
    name: "settleModal",
    props:['cbs', 'id','name'],
    data(){
        return {
            isFinish: false,
            formLoading: false,
            formItem: {
                finish_reason: '',
            },
            rules: {
                finish_reason: [
                    { required: true, message: '请输入结单的理由，50字之内', trigger: 'blur' },
                    { min: 1, max: 50, message: '请输入结单的理由，50字之内', trigger: 'blur' }
                ],
            },
        }
    },
    mounted() {
        this.fetchTqFinish(this.id)
    },
    methods: {
        submitModal() {
            if(this.isFinish) {
                this.$refs.form.validate((valid) => {
                    if (valid) {
                        this.fetchWorkOrderFinish(this.id)
                    } else {
                        return false;
                    }
                });
            }else{
                this.fetchWorkOrderFinish(this.id)
            }
        },
        hideModal() {
            matomoFun.trackEvent(this.name||'素材工单(工单管理-制作中)', '点击', '列表(结算-取消)')
            this.$emit('close');
        },
        // 是否可以提前结单
        fetchTqFinish(id) {
            API.getWorkOrderCheckFinish({order_id:id}).then(res=>{
                this.isFinish = res.data.isFinish
            }, err=>{
                this.$message.error(err.info)
            })
        },
        //结单
        fetchWorkOrderFinish(id) {
            matomoFun.trackEvent(this.name||'素材工单(工单管理-制作中)', '点击', '列表(结算-提交)')
            this.formLoading = true
            API.postWorkOrderFinish({order_id:id,finish_reason:this.formItem.finish_reason, isFinish: this.isFinish}).then(res=>{
                this.$message.success(res.info)
                this.cbs.onSubmit()
                this.formLoading = false
            },err=>{
                this.$message.error(err.info)
            }).finally(()=>{
                this.formLoading = false
            })
        },
    }
}
</script>

<style scoped>

</style>
